import angular from 'angular';

/**
 * @ngdoc overview
 * @name commonModule.modals
 * @description
 * # commonModule.modals
 * Collection of directives for modals
 */
const modals = angular.module('commonModule.modals', []);

/**
 * @ngdoc directive
 * @name commonModule.modals.directive:ngReallyClick
 * @description
 * Directive for displaying modal, to make user confirm their action
 */
modals.directive('ngReallyClick', ['$modal', '$translate', function ($modal, $translate) {
    'use strict';
    return {
        restrict: 'A',
        scope: {
            ngReallyHeader: '@',
            ngReallyMessage: '@',
            ngReallyClick: '&'
        },
        link: function (scope, element) {
            element.bind('click', function () {
                var header = scope.ngReallyHeader;
                var message = scope.ngReallyMessage;
                var modalInstance = $modal.open({
                    templateUrl: 'views/common/components/modals/confirmDialog.tpl.html',
                    controller: ['$scope', '$modalInstance', function ($scope, $modalInstance) {
                        $scope.ok = function () {
                            $modalInstance.close(true);
                        };

                        $scope.cancel = function () {
                            $modalInstance.dismiss('cancel');
                        };

                        $scope.header = header || $translate.instant('MODAL.CONFIRM.HEADER');
                        $scope.message = message || $translate.instant('MODAL.CONFIRM.MSG');
                    }]
                });

                modalInstance.result.then(function (isConfirmed) {
                    if (isConfirmed) {
                        scope.ngReallyClick();
                    }
                }).catch(() => {});
            });
        }
    };
}]);

/**
 * @ngdoc directive
 * @name commonModule.modals.directive:modalClose
 * @description
 * Directive for 'close' button for modals
 */
modals.directive('modalClose', function () {
    'use strict';
    return {
        restrict: 'AE',
        replace: true,
        scope: false,
        controller: ['$scope', function ($scope) {
            $scope.close = function () {
                $scope.modal.dismiss('cancel');
            };
        }],
        template: '<div class="modal-close"><i class="li-close" ng-click="close()"></i></div>'
    };
});

export default modals;
